<div class="view-toggle" *ngIf="showListSelect">
  <i (click)="cardViewClick()" class="material-icons" [class.selected]="currentView == 'CARD'">view_module</i>
  <i (click)="listViewClick()" class="material-icons" [class.selected]="currentView == 'LIST'">view_headline</i>
</div>
<div class="card-container">
  <div *ngIf="title" class="title">
    <h3>{{ title }}</h3>
  </div>
  <div class="band" *ngIf="currentView == 'CARD'">
    <ng-container *ngIf="!useSystems; else showSystemCard">
      <app-card-view-simple-card *ngFor="let site of result" [showEdit]="showEdit" [showDelete]="showDelete"
        [title]="site.name" [links]="" [defaultLink]="site.url" [actionButtons]="actionButtons"
        (onDelete)="onDeleteSite(site.uid, $event)" (onUpdate)="onUpdateSite(site.uid, $event)">
        {{ site.location }}
        <br>
      </app-card-view-simple-card>
    </ng-container>
    <ng-template #showSystemCard>
      <app-card-view-system-card *ngFor="let system of result" [system]="system">
      </app-card-view-system-card>
    </ng-template>
    <ng-content select="[card]"></ng-content>
    <app-card-view-add-card *ngIf="showAdd" (click)="add($event)"></app-card-view-add-card>
  </div>
  <div class="list" *ngIf="currentView == 'LIST'">
    <app-list-view-simple-card *ngFor="let site of result" [title]="site.name" [showEdit]="showEdit"
      [showDelete]="showDelete" [links]="" [defaultLink]="site.url" [actionButtons]="actionButtons"
      (onDelete)="onDeleteSite(site.uid, $event)" (onUpdate)="onUpdateSite(site.uid, $event)">
    </app-list-view-simple-card>
    <ng-content select="[list]"></ng-content>
  </div>
</div>